import React, { useEffect, useState } from 'react'
import { Separator } from '../../utils/utils';
// import useNewItemChange from '../../EHR Settings/Templates/OpenTemplate/FormBuilder/hooks/useNewItemChange';
// import ValidationText from './ValidationText';
// import SuperSearchList from '../../../../../../shared/SuperSearch/SuperSearchList';

// Viewer Component for Displaying the Checklist
const Dropdown = ({ item, setItem, activeAccordion, dragHandleProps }) => {

    const selectedOptions = item.selectedOptions?.split(Separator).length > 0
        ? item.selectedOptions.split(Separator).map(optStr => {
            const hasSelected = optStr.includes("(D)");
            const baseLabel = optStr.split("(D)")[0].split("[")[0];

            const metaMatch = optStr.match(/\[(.*?)\]/);
            let textResponse = "false";
            let hintText = "";
            let value = "";

            if (metaMatch) {
                const parts = metaMatch[1].split("|");
                parts.forEach(p => {
                    if (p.startsWith("TR=")) textResponse = p.split("=")[1];
                    if (p.startsWith("hintText=")) hintText = p.split("=")[1].replace(/'/g, "");
                    if (p.startsWith("value=")) value = p.split("=")[1].replace(/'/g, "");
                });
            }

            return {
                content: baseLabel,
                checked: hasSelected,
                textResponse: textResponse,
                hintText: hintText,
                value: value
            };
        })
        : [];
    console.log("selectedOptionsDropdown", selectedOptions)
    return (
        <>
            <div className="d-flex align-items-center gap-15">
                <label htmlFor="" className="text fs-14 ar-light-color w-231px text-end">{item.content}</label>
                <>
                    {selectedOptions.length > 0 &&
                        selectedOptions.map((option, index) => (
                            <>
                                {selectedOptions && selectedOptions[index]?.checked &&
                                    <div className="d-flex gap-1 align-items-center">
                                        <p className="text text-black fs-14">{option.content}</p>
                                    </div>}
                            </>))}
                    {selectedOptions?.every(it => it.checked === false) && <p className="text fs-14 text-black">N/A</p>}
                </>
            </div>
        </>
    );
};

export default Dropdown